var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarmBowl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M9 2.1L8 5.4l1 2.2-1 3.3m8-8.8l-1 3.3 1 2.2-1 3.3M12.5 1l-1 4.125 1 2.75-1 4.125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M3.17 15.353l-.162-.313.001-.001-.237-.46L1.62 12.34c-.284-.678-.043-1.478.478-1.823h0l.006-.005L6.2 7.698a1.15 1.15 0 01.641-.198h10.318c.221 0 .438.065.628.19l4.12 2.831h0l.007.005c.509.337.752 1.141.462 1.823l-.015.034-1.52 2.947-.006.012-.006.012a.328.328 0 01-.02.04l-.01.015-.008.017-1.706 3.302c-1.004 1.696-2.959 2.772-5.126 2.772h-3.92c-2.169 0-4.125-1.078-5.128-2.776l-.014-.026L3.194 15.4h0l-.005-.008-.008-.016-.002-.003-.004-.01-.005-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M2 13c3.519 1.154 6.255 2 10 2s6.481-.846 10-2"
  }));
}
export default SvgIconWarmBowl;